// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__GpOBO","title":"AfterBackImages_title__apnyi","images":"AfterBackImages_images__13P6I"};